/**
 * Match current URL to menu paths (exact or nested under a submenu path).
 */
export function pathMatchesRoute(pathname, basePath) {
  if (!basePath || !pathname) return false;
  if (pathname === basePath) return true;
  return pathname.startsWith(`${basePath}/`);
}

/**
 * Which top-level menu label (e.g. "HR Setup") should have its submenu open for this URL.
 */
export function findParentMenuLabelForPath(menuItems, pathname) {
  if (!menuItems?.length || !pathname) return null;
  for (const item of menuItems) {
    if (!item.subMenu?.length) continue;
    const hit = item.subMenu.some(
      (sub) => !sub.isGroupTitle && sub.path && pathMatchesRoute(pathname, sub.path)
    );
    if (hit) return item.label;
  }
  return null;
}

/**
 * Among sibling submenu items, the most specific path that matches the URL (for highlight).
 */
export function getLongestMatchingSubPath(subMenu, pathname) {
  if (!subMenu?.length || !pathname) return null;
  let best = null;
  for (const sub of subMenu) {
    if (sub.isGroupTitle || !sub.path) continue;
    if (pathMatchesRoute(pathname, sub.path)) {
      if (!best || sub.path.length > best.path.length) best = sub;
    }
  }
  return best?.path ?? null;
}
